import { Select } from "app/components/Select";
import React from "react";
import { planningOptions } from "../data";
import { PlanningViewBy } from "../types";

interface IProps {
  selectedViewType: PlanningViewBy;
  onChange: (val: PlanningViewBy) => void;
}

export default function Filter({ selectedViewType, onChange }: IProps) {


  return (
    <div className="flex flex-col gap-[6px]">
      <Select
        options={planningOptions}
        containerClassName="w-full"
        id="language"
        value={selectedViewType}
        onChange={(value) => {
          onChange(value as PlanningViewBy);
        }}
        inputClassName="bg-white cursor-pointer hover:bg-gray-200"
      />
      <span className="font-normal text-[14px] leading-[21px] tracking-normal text-secondary break-words">{`Drag and drop tickets to add them to ${selectedViewType}`}</span>
    </div>
  );
}
